import React from 'react';
import PropTypes from 'prop-types';
import Slider from '@fuww/library/src/HighlightedJobs';
import { useIntl } from 'react-intl';
import CategoryHeading from '@fuww/library/src/CategoryHeading';
import withQuery from '../../lib/withQuery';
import messages from '../../lib/messages.json';
import { useSiteContext } from '../SiteContext';
import LogoImage from '../ImageWithUrls';

const HighlightedJobs = ({ data }) => {
  const intl = useIntl();
  const { jobsLocale } = useSiteContext();

  return (
    <>
      {data.jobs.length > 0 && (
      <CategoryHeading jobOfTheWeek>
          {intl.formatMessage(messages.jobOfTheWeek)}
      </CategoryHeading>
      )}
      <Slider
        jobs={data.jobs.map((job) => {
          const { company: { logoUrls, name } } = job;

          return {
            job,
            logo: logoUrls[0] && (
            <LogoImage
              imageUrls={logoUrls}
              alt={name}
              title={name}
              objectFit="contain"
              maxHeight="65px"
              width="170px"
              sizes="170px"
              srcSet={`${logoUrls[1]
              } 170w, ${logoUrls[2]
              } 340w, ${logoUrls[3]
              } 510w`}
            />
            ),
          };
        })}
        locale={jobsLocale}
        applyButtonText={intl.formatMessage(messages.applyButtonText)}
      />
    </>
  );
};

HighlightedJobs.propTypes = {
  data: PropTypes.shape({
    jobs: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

HighlightedJobs.defaultProps = {
  data: {},
};

export default withQuery(HighlightedJobs);
